import * as React from 'react';
import { Link } from 'react-router-dom';
import '../../OurTeam.css';

interface MemberCardComponentProps {
  imagePath: string;
  profilePath?: string;
  linkedinPath?: string;
  name: string;
  title: string;
  description: string;
}
const MemberCardComponent = (props: MemberCardComponentProps) => {

  if (props.profilePath) {
    return (
      <Link to={'/nuestro-equipo/' + props.profilePath}>
        <div className="simple-card team-card shadow pointer">
          <div className="crop-image-simple-card">
            <img
              alt={props.name}
              src={props.imagePath}
            />
          </div>
          {props.linkedinPath ? <a href={props.linkedinPath} target="_blank" className="linkedin-badge"/> : null}
          <div className="team-content">
            <p className="deco-title featured c-black-text f-s-16">{props.name}
              <br/>
              <span className="primary-font f-w-100">{props.title}</span>
            </p>
            <p>{props.description}…</p>
            <p className="text-right">
              <span className="arrow-right-grey"/>
            </p>
          </div>
        </div>
      </Link>
    );
  } else {
    return (
      <div className="simple-card team-card shadow">
        <div className="crop-image-simple-card">
          <img
            alt={props.name}
            src={props.imagePath}
          />
        </div>
        {props.linkedinPath ? <a href={props.linkedinPath} target="_blank" className="linkedin-badge"/> : null}
        <div className="team-content">
          <p className="featured c-black-text f-s-16">{props.name}
            <br/>
            <span className="primary-font f-w-100">{props.title}</span>
            <br/>
            <span className="primary-font f-w-100">{props.description}</span>
          </p>
        </div>
      </div>
    );
  }
};

export default MemberCardComponent;


// WEBPACK FOOTER //
// ./src/modules/our-team/index/partials/MemberCard.component.tsx